(function () {
    'use strict';
    angular.module('app.directive')
        .directive('a', a);

    function a(commonService) {
        return {
            restrict: 'E',
            link: function (scope, elem, attrs) {
                if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                    elem.on('click', function (e) {
                        e.preventDefault();
                    });
                } else {
                    elem.on('click', function () {
                        if (elem.attr('href') !== undefined) {
                            commonService.saveLogFlow(elem.attr('href'));
                        }
                    });
                }
            }
        };
    }
})();